import { Component } from '@angular/core';
import {   NavController,App, NavParams, ModalController } from 'ionic-angular';
import { DbservicesProvider,ChatService } from '../../providers/dbservices/dbservices';
import 'rxjs/add/observable/interval';

import { OrderdetailsPage } from '../../pages/orderdetails/orderdetails';
import { LoginPage } from '../../pages/login/login';

var pull = 0;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  order_type;
  order_list = [];
  pending_list = [];
  // all_order =[];
  pageNo = 0;
  ppageNo = 0;
  // apageNo = 0;
  loadMoreData = false;
  ploadMoreData = false;
  // aloadMoreData = false;
  pageNos = false;
  ppageNos = false;
  apageNos = false;
  connection;
  // messages = [];
  Isorder = false;
  Isordercomplete = false;

  constructor(public DBservice: DbservicesProvider, public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, private chatService: ChatService) {
    this.order_type = 'Pending';
    this.connection = this.chatService.getMessages().subscribe(message => {
      // this.messages.push(message);
    setTimeout(() => {
      this.order_list = [];
      this.pending_list = [];
      this.pageNo = 0;
      this.ppageNo = 0;
      this.loadMoreData = false;
      this.ploadMoreData = false;
      this.Orderlist(0);
      this.PendingOrderlist(0)
    }, 1000);

    })

    // this.Orderlist(this.pageNo);
    // this.PendingOrderlist(this.ppageNo)


    // this.order_list = []
      // this.pending_list =[]
      // this.all_order =[]
      // this.Allorderlist(this.apageNo)
      
  }

  ionViewWillEnter() {
      this.order_list = [];
      this.pending_list = [];
      this.pageNo = 0;
      this.ppageNo = 0;
      this.loadMoreData = false;
      this.ploadMoreData = false;
      this.Orderlist(0);
      this.PendingOrderlist(0)
    this.update_playid()
    // if (localStorage.CustomerId == undefined) {
    //   location.href = "#/login"
    // }
    // else {
      // if(pull == 0){
      // this.order_list = []
      // this.pending_list =[]
      // this.all_order =[]
      // this.Allorderlist(this.apageNo)
      // this.Orderlist(this.pageNo)
      // this.PendingOrderlist(this.ppageNo)
      // }
    }
  // }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderPage');
  }

  update_playid() {
    if (localStorage.adminRefId) {
      var datas = {
        // player_id: localStorage.deviceid,
        // user:localStorage.adminRefId,
        // user_type:"Shop User"
        document:'Shop User',
        user:localStorage.adminRefId,
        device_id:localStorage.deviceid,
        enabled:1
      }
      this.DBservice.update_playerid(datas)
        // .map(res => res.json())
        .then(data => {
          console.log(data)
        }, error => {
          console.log(JSON.stringify(error.json()));

        });
    }
  }

  order_tab(order_type) {
    
  }

  Orderlist(page) {
    var orderdata = {
      // name: localStorage.customerRefId,
      restaurantId:localStorage.restaurant,
      limit_start: page,
      limit_page_length: 10,
      status: ''
    }
    this.DBservice.order_list(orderdata)
      .then(data => {
        console.log(data)
        // console.log(data.message);
        if (data.message != undefined) {
          for (var i = 0; i < data.message.length; i++) {
            var k = i;
            // console.log(this.order_list)
            this.order_list.push(data.message[k])
          }
          console.log(this.order_list);
          if (data.message.length == 0) {
            this.loadMoreData = true;
          }
          if(this.order_list.length == 0)
            this.Isorder = true;
        this.pageNos = true
        }
        else {
          this.Isorder = true;
          this.pageNos = false;
          this.loadMoreData = true;
        }
        if(this.order_list.length != 0)
          this.Isorder = false;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  PendingOrderlist(page) {
    var orderdata = {
      restaurantId:localStorage.restaurant,
      // name: localStorage.customerRefId,
      limit_start: page,
      limit_page_length: 10,
      status: 'Placed'
    }
    this.DBservice.order_list(orderdata)
      .then(data => {
        console.log(data);
        if (data.message != undefined) {
          for (var i = 0; i < data.message.length; i++) {
            var k = i;
            // console.log(this.order_list)
            this.pending_list.push(data.message[k])
          }
          console.log(this.pending_list);
          if (data.message.length == 0) {
            this.ploadMoreData = true;
          }
          if(this.pending_list.length == 0)
            this.Isordercomplete = true;
          this.ppageNos = true
        }
        else {
          this.Isordercomplete = true;
          this.ppageNos = false;
          this.ploadMoreData = true;

        }
        if(this.pending_list.length != 0)
          this.Isordercomplete = false;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  doInfinite(infiniteScroll) {
    if (this.pageNos == true) {
      this.pageNo = this.pageNo + 10;
      this.Orderlist(this.pageNo);
    }
    setTimeout(() => {
      infiniteScroll.complete();
    }, 50);
  }

  doInfinitePending(infiniteScroll) {
    if (this.ppageNos == true) {
      this.ppageNo = this.ppageNo + 10;
      this.PendingOrderlist(this.ppageNo);
    }
    setTimeout(() => {
      infiniteScroll.complete();
    }, 50);
  }


  doRefresh(refresher) {
    // this.order_type = 'Pending';

    this.order_list = [];
    this.pageNo = 0;
    this.loadMoreData = false;
    this.pageNos = false;
    this.pending_list = [];
    this.ppageNo = 0;
    this.ploadMoreData = false;
    this.ppageNos = false;

    this.PendingOrderlist(this.ppageNo);
    this.Orderlist(this.pageNo)
    // this.Allorderlist(this.apageNo)
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }

  orderdetail(list) {
    pull = 1;
    this.navCtrl.push('OrderdetailsPage', { item: list })
    // console.log(list)
    // let modal = this.modalCtrl.create('OrderdetailsPage', { item: list });
    // modal.present();
  }

  // update_playid() {
  //   if (localStorage.adminRefId) {
  //     var datas = {
  //       player_id: localStorage.deviceid,
  //       user:localStorage.adminRedId,
  //       user_type:"Shop Users"

  //     }
  //     this.DBservice.update_playerid(datas)
  //       // .map(res => res.json())
  //       .then(data => {
  //         console.log(data)
  //       }, error => {
  //         console.log(JSON.stringify(error.json()));

  //       });
  //   }
  // }

}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts